import React, { useEffect, useState } from 'react';
import Slider from '../../../../../../components/slider/pure-slider-container';

const SettingsSlider = ({
  id,
  label,
  initialValue,
  defaultValue,
  min,
  max,
  unit,
  step,
  onChange,
}) => {

  const [value, setValue] = useState(defaultValue);
  const [timer, setTimer] = useState(null);

  const handleChange = (newValue) => {

    setValue(newValue);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        onChange(id, newValue);
      }, 1000),
    );
  };

  useEffect(() => {
    setValue(initialValue ?? defaultValue);
  }, [initialValue]);

  return (
      <>
        <Slider
            skipMargin
            label={label}
            domain={[min, max]}
            value={value}
            step={step}
            handleChange={handleChange}
            name={label}
            suffix={unit}
            isTheme
        />
      </>
  );
};

export default SettingsSlider;
